import React from 'react';
import './SummaryCards.css';

const SummaryCards = ({ summary }) => {
  if (!summary) return null;

  const cards = [
    {
      title: 'Total Companies',
      value: summary.total_companies || 0,
      icon: '🏢',
      color: '#4CAF50'
    },
    {
      title: 'Total Users',
      value: summary.total_users || 0,
      icon: '👥',
      color: '#2196F3'
    },
    {
      title: 'Usage Records',
      value: summary.total_usage_records || 0,
      icon: '📊',
      color: '#FF9800'
    },
    {
      title: 'Applications',
      value: summary.total_applications || 0,
      icon: '💻',
      color: '#9C27B0'
    }
  ];

  return (
    <div className="summary-cards">
      {cards.map((card, index) => (
        <div key={index} className="summary-card" style={{ borderLeftColor: card.color }}>
          <div className="card-icon" style={{ backgroundColor: card.color }}>
            {card.icon}
          </div>
          <div className="card-content">
            <h3>{card.title}</h3>
            <p className="card-value">{card.value.toLocaleString()}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards; 